import React from 'react'
import { Layout } from 'antd';
import Sidebar from './Module/Sidebar'
import Headers from './Module/Headers'
import Contents from './Module/Content'
import { notification } from 'antd'
import * as actions from '@/store/action/action'
import STORE from '@/store/index'
// import Footers from './Module/Footer'

/**
 * 调整到socket指定的方法
 * @param data
 */
function toSocketPage(data){
    if(data.type === 'alertTicket'){
        window.location.href = '/alarmManagement/alarmList?serialNumber='+data.serialNumber
    }else if(data.type === 'inspectionTicket'){
        window.location.href = '/workOrderAdministration/inspectWorkOrderList?serialNumber='+data.serialNumber
    }else if(data.type === 'constructionTicket'){
        window.location.href = '/workOrderAdministration/constructionList?serialNumber='+data.serialNumber
    }else if(data.type === 'faultTicket'){
        window.location.href = '/workOrderAdministration/faultworkOrderList?serialNumber='+data.serialNumber
    }
}

function test(){
    if(!React.$socket || React.$socket.readyState === 3) {
        const token = React.$util.getToken()
        const socketUrl = React.$util.getSocketUrl()
        React.$socket = new WebSocket(socketUrl + token)
        React.$audio =  new Audio(require('./../assets/12025.mp3').default)
        //连接成功建立的回调方法
        React.$socket.onopen = function(event){
            console.log('socket 链接成功')
            if(React.$socketInterval){
                clearInterval(React.$socketInterval)
            }
            // 每10s中向服务器发送一次心跳消息
            React.$socketInterval = setInterval(() => {
                React.$socket.send('心跳消息')
            },10000)
        }
        //接收到消息的回调方法
        React.$socket.onmessage = function(event){
            console.log('接受消息')
            // console.log(event.data)
            const data = JSON.parse(event.data)
            if(data.type) {
                if (data.type === 'alertTicket') {
                    STORE.dispatch(actions.alertScoketInfo(Math.random()))
                }
                React.$audio.play()
                notification.info({
                    message: data.title,
                    description: data.msg,
                    duration: null,
                    placement: 'bottomRight',
                    onClick: () => {
                        toSocketPage(data)
                    }
                })
            }
        }
        //连接关闭的回调方法
        React.$socket.onclose = function(){
            // console.log('close');
        }
        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = function(){
            React.$socket.close();
        }
    }
}

function Layouts(props) {
    return (
        <Layout style={{ minHeight: '100vh', minWidth:'1200px' }}>
            <Sidebar routerPath={props.history}/>
            <Layout className="site-layout">
                <Headers history={props.history}/>
                <Contents routerPath={props.history}/>
                {/*<Footers/>*/}
                {/*{test()}*/}
            </Layout>
        </Layout>
    )
}
export default Layouts
